import React from "react";
import {Container, Navbar, Nav} from "react-bootstrap";
import { Link } from "react-router-dom";

function Navigation() {
    return (
        <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
                <Navbar.Brand as={Link} to="/">Porter's Blog</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/bio">Bio</Nav.Link>
                        <Nav.Link as={Link} to="/translation">Translation</Nav.Link>
                        <Nav.Link as={Link} to="/reading">Reading</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Navigation;
